import { type QueryObserverOptions, useQuery } from 'react-query'

import useAuth from 'hooks/use-auth'
import { kubernetesQueryKeys } from 'queries/kubernetes/query-keys'
import { getKubernetesTargetsKinds } from 'queries/kubernetes/query-utils'
import { ms } from 'utils/millisecond'

import type { AxiosError } from 'axios'

export function useGetKubernetesTargetsKinds(
  options?: QueryObserverOptions<string[]>
) {
  const { currentTeamId } = useAuth()

  return useQuery<string[], AxiosError, string[]>({
    ...options,
    queryKey: kubernetesQueryKeys.getKubernetesTargetsKinds({
      teamId: currentTeamId
    }),
    queryFn: getKubernetesTargetsKinds,
    staleTime: ms.minutes(5)
  })
}
